"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekdayIntervals = exports.getNextWeekdayDate = exports.weekdayToISOInt = exports.WeekdayPostInterface = exports.WeekdayGetInterface = exports.WeekdayData = exports.WeekdayNameValues = exports.WeekdayName = void 0;
const t = __importStar(require("io-ts"));
const luxon_1 = require("luxon");
exports.WeekdayName = t.union([
    t.literal('monday'),
    t.literal('tuesday'),
    t.literal('wednesday'),
    t.literal('thursday'),
    t.literal('friday'),
    t.literal('saturday'),
    t.literal('sunday'),
]);
exports.WeekdayNameValues = exports.WeekdayName.types.map((type) => type.value);
exports.WeekdayData = t.type({
    name: exports.WeekdayName,
});
exports.WeekdayGetInterface = t.type(Object.assign(Object.assign({}, exports.WeekdayData.props), { id: t.number, resourceName: t.string }));
exports.WeekdayPostInterface = exports.WeekdayData;
function weekdayToISOInt(weekday) {
    switch (weekday) {
        case 'monday':
            return 1;
        case 'tuesday':
            return 2;
        case 'wednesday':
            return 3;
        case 'thursday':
            return 4;
        case 'friday':
            return 5;
        case 'saturday':
            return 6;
        case 'sunday':
            return 7;
    }
}
exports.weekdayToISOInt = weekdayToISOInt;
function getNextWeekdayDate(weekdayName) {
    const targetWeekdayInt = weekdayToISOInt(weekdayName);
    const now = luxon_1.DateTime.local();
    const today = now.weekday;
    let result;
    // We did not yet pass the target weekday in the current week...
    if (today <= targetWeekdayInt) {
        // hence, we can just use the target day from the current week
        result = now.set({ weekday: targetWeekdayInt });
    }
    else {
        // otherwise we need to get the target day from the next week
        result = now
            .plus(luxon_1.Duration.fromObject({ weeks: 1 }))
            .set({ weekday: targetWeekdayInt });
    }
    return result.startOf('day');
}
exports.getNextWeekdayDate = getNextWeekdayDate;
function getWeekdayIntervals(weekdayName) {
    const targetWeekdayInt = weekdayToISOInt(weekdayName);
    const now = luxon_1.DateTime.local();
    const today = now.weekday;
    function toDayInterval(dt) {
        const dtDayStart = dt.startOf('day');
        const start = dtDayStart.set({ hour: 0, minute: 0 });
        const end = dtDayStart.set({ hour: 23, minute: 59 });
        return luxon_1.Interval.fromDateTimes(start, end);
    }
    let result;
    if (today < targetWeekdayInt) {
        // We did not yet pass the target weekday in the current week...
        // hence, we can just use the target day from the current week
        const weekdayDate = now.set({ weekday: targetWeekdayInt });
        result = [toDayInterval(weekdayDate)];
    }
    else if (today === targetWeekdayInt) {
        // if the target day is the current day, the user either wants to see today or the same day of next week, so we add
        // both intervals
        const weekdayDateThisWeek = now.set({ weekday: targetWeekdayInt });
        const weekdayDateNextWeek = now
            .set({ weekday: targetWeekdayInt })
            .plus(luxon_1.Duration.fromObject({ weeks: 1 }));
        result = [
            toDayInterval(weekdayDateThisWeek),
            toDayInterval(weekdayDateNextWeek),
        ];
    }
    else {
        // otherwise we need to get the target day from the next week
        const weekdayDate = now
            .plus(luxon_1.Duration.fromObject({ weeks: 1 }))
            .set({ weekday: targetWeekdayInt });
        result = [toDayInterval(weekdayDate)];
    }
    return result;
}
exports.getWeekdayIntervals = getWeekdayIntervals;
//# sourceMappingURL=Weekday.js.map